import controller from './login.controller';
import template from './login.html';
import './login.scss';
/**
 * @ngdoc component
 * @name login
 * @description
 * The login component of the app.
 *
 * @memberof account
 */
export default {
  /**
   * The controller class for the component.
   * @type {LoginController}
   */
  controller,
  /**
   * The HTML template for the component.
   * @type {String}
   */
  template,
};



// WEBPACK FOOTER //
// ./src/frontend/modules/account/components/login/login.component.js